import { Component, Inject, OnInit } from '@angular/core';
import { InterpretationService } from '../../interpretation.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { InspectionAdditionalObservationListsViewModel } from '../../../../modules/inspection/models/create-inspection.model';
import { NotificationsService } from 'angular2-notifications';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent implements OnInit {
  isEdit:boolean=false;
  inspectionId: number;
  obsId:number;
  title:string;
  isEditDeleteObs: boolean = false;
  observationLists: InspectionAdditionalObservationListsViewModel[]= [];
  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private _data: any,
    private _interp: InterpretationService,
    private _notification: NotificationsService
  ) { }

  ngOnInit() {
    this.isEdit = this._data.isEdit;
    this.inspectionId = this._data.inspectionId;
    this.obsId = this._data.obsId;
    this.title = this._data.Title;
    this.observationLists = this._data.observationLists;
  }

  onNoClick(){
    this.dialogRef.close(false);
  }

  confirm(){
    this.dialogRef.close(true);
  }

  updateAdditional(){
    const exists = this.observationLists?.some(x => x.Title?.trim().toLowerCase() === this.title?.trim().toLowerCase());
    if (exists) {
      this._notification.warn(
        'Duplicate Observation',
        'An observation with the same title already exists.'
      );
      return;
    }
    this._interp.EditAdditionalObsPoint(this.inspectionId, this.obsId, this.title).subscribe(res=>{
      if(res.m_Item1==true){
        this.dialogRef.close(true);
      }else{
        this.dialogRef.close(false);
      }
    })
  }
}
